import React from "react";
import { useContent } from "../../lib/content";

export const OfferSteps = () => {
  const { howItWorks: w } = useContent();
  return (
  <section data-testid="offer-how-it-works" className="section-pad bg-white tex-grid-light">
    <div className="max-w-[1280px] mx-auto px-5 lg:px-8">
      <span className="eyebrow">{w.eyebrow}</span>
      <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-[#0a1f44]">{w.heading}</h2>
      <ol className="mt-10 grid md:grid-cols-3 gap-6">
        {w.steps.map((s, i) => (
          <li key={s.t} data-testid={`offer-step-${i + 1}`} className="relative bg-white rounded-2xl p-7 border border-slate-200 overflow-hidden">
            <span className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-[#3b9dff] to-[#0a1f44]" />
            <span className="w-12 h-12 rounded-2xl bg-gradient-to-br from-[#3b9dff] to-[#2b6fd6] text-white text-xl font-extrabold flex items-center justify-center shadow-[0_10px_24px_-8px_rgba(59,157,255,0.7)]">{i + 1}</span>
            <h3 className="mt-3 text-xl font-bold text-[#0a1f44]">{s.t}</h3>
            <p className="mt-2 text-slate-600 leading-relaxed">{s.d}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
  );
};
